export const SetUserActions = (actions) => {
    return {
        type: "SET_USER_ACTIONS",
        payload: actions
    }
}

export const SetDisplayName = (displayName) => {
    return {
        type: "SET_DISPLAY_NAME",
        payload: displayName
    }
}

export const SetUserMemberNumber = (memberNumber) => {
    return {
        type: "SET_USER_MEMBER_NUMBER",
        payload: memberNumber
    }
}

export const SetUserMemberName = (memberName) => {
    return {
        type: "SET_USER_MEMBER_NAME",
        payload: memberName
    }
}

export const SetUserEmail = (email) => {
    return {
        type: "SET_USER_EMAIL",
        payload: email
    }
}

export const SetUserRole = (role) => {
    return {
        type: "SET_USER_ROLE",
        payload: role
    }
}

export const SetUserID = (userID) => {
    return {
        type: "SET_USER_ID",
        payload: userID
    }
}

export const SetUserAccountId = (accountId) => {
    return {
        type: "SET_USER_ACCOUNT_ID",
        payload: accountId
    }
}

export const SetUserPreviousLoginDate = (previousLoginDate) => {
    return {
        type: "SET_USER_PREVIOUS_LOGIN_DATE",
        payload: previousLoginDate
    }
}

export const SetFiltering = (filterName, filters) => {
    return {
        type: "SET_FILTER",
        name: filterName,
        payload: filters
    }
}

export const SetRouting = (title, route, id) => {
    return {
        type: "SET_ROUTE",
        title: title,
        route: route,
        id: id
    }
}

export const SetTyreCheck = (data) => {
    return {
        type: "SET_TYRE_CHECK",
        payload: data
    };
};

export const SetEarnedRecognitionPeriodOrder = (newestPeriodFirst) => {
    return {
        type: "SET_EARNED_RECOGNITION_PERIOD_ORDER",
        payload: newestPeriodFirst
    };
};

export const SetRulesEngineDriver = (driver) => {
    return {
        type: "SET_RULES_ENGINE_DRIVER",
        payload: driver
    };
};

export const SetRulesEngineRange = (range) => {
    return {
        type: "SET_RULES_ENGINE_RANGE",
        payload: range
    };
};

export const SetRulesEngineDiffViewerReturn = (diffViewerReturn) => {
    return {
        type: "SET_RULES_ENGINE_DIFF_VIEWER_RETURN",
        payload: diffViewerReturn
    };
};

export const SetPsvScreensFromLoading = () => {
    return {
        type: "SET_PSV_SCREENS_FROM_LOADING"
    };
};

export const SetPsvScreensFrom = (screensFrom) => {
    return {
        type: "SET_PSV_SCREENS_FROM",
        payload: screensFrom
    };
};

export const SetPsvScreensFromFailed = () => {
    return {
        type: "SET_PSV_SCREENS_FROM_FAILED"
    };
};

export const ResetStore = () => {
    return {
        type: "RESET_STORE"
    }
}
